import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {OccupationalProfileComponent} from "./occupationalprofile/occupational-profile.component";
import {ExternalRoute} from './core/external-route.component';

const routes: Routes = [
    {
        path: ':id/:urlName',
        component: OccupationalProfileComponent
    },
	new ExternalRoute('**', '/beroepnietgevonden')
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{
      anchorScrolling: 'enabled'
  })],
  exports: [RouterModule]
})
export class BeroepenPaginaRoutingModule { }
